import React from 'react';

import immersionRCLapRF from '../../../main/assets/images/lapRf/immersionrc-lap-rf.webp';

export const Hero = () => {
  return (
    <section className="laprf-hero">
      <div className="laprf-hero-bg" />
      <div className="laprf-hero-text">
        <div className="laprf-hero-title-section">
          <h1 className="laprf-hero-subtitle">Lap Rf</h1>
          <h2 className="laprf-hero-title">Timing perfected</h2>
        </div>
        <p className="laprf-hero-description">
          The LapRF 8-Way is a premium RF race timing system designed to deliver
          unparalleled performance for 1-8 pilots. It detects drones via their
          5.8GHz transmitters as they pass through the start/finish gate,
          ensuring flawless and precise race timing.
        </p>
        <div className="dreamX__discover--button">
          <a
            href="https://shop.orqafpv.com/products/immersionrc-laprf-8?_pos=1&_sid=19f8b9194&_ss=r"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--primary btn--med"
            onMouseDown={event => event.preventDefault()}
          >
            buy now
          </a>
        </div>
      </div>
      <img
        src={immersionRCLapRF}
        alt="Drone Detection System Product"
        className="laprf-hero-product"
      />
    </section>
  );
};
